<div class="modal-header">         
    <h3 class="modal-title">{{ 'select-bet-section' | translate}}</h3>
    <button class="close" (click)="modalRef.hide()">
        <img src="assets/img/common/close-icon.png" alt="">
    </button>
</div>

<div class="modal-body">
    
    <div *ngIf="twodSectionList.length == 0" style="height: 256px;">
        <div class="loader-wrapper">
            <div class="loader-icon"></div>
        </div>
    </div>
    
    <ng-container *ngIf="twodSectionList.length > 0">
        <div *ngFor="let twodSectionListObj of twodSectionList">
            <span *ngIf="twodSectionListObj.toTime != null" class="btn btn-block bet-section-button"
            [ngClass]="{'not-bet' : twodSectionListObj.isClosed, 'active': twodSectionListObj.isSelected }"
            (click)="selectBetSection(twodSectionListObj.id)">{{ twodSectionListObj.sectionName}}</span>   
        </div>
        <!-- <div class="text-center mt-2">
            <button type="button" class="btn btn-block twod-bet-btn"
             (click)="twoDbet()">{{ 'bet' | translate}}</button>
        </div> -->

        <div class="text-center mt-2">
            <button
              type="button"
              class="btn btn-block twod-bet-btn"
              [ngClass]="{
                'active': isDisabled,
                'not-bet': isDisabled
              }"
              [disabled]="isDisabled"
              (click)="twoDbet()"
            >
              {{ 'bet' | translate }}
            </button>
        </div>          
    </ng-container>

</div>